import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';
//import {buttonStyle} from '../Common/style'

class InventoryAdjustments extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,

            adjustmentDetail: {
              rows: [],
              filters: {},
              sortColumn: null,
              sortDirection: null,
            },
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchInventoryAdjustments();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventoryAdjustments is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.inventoryAdjustments;
        if (nextProps.inventoryAdjustments && nextProps.inventoryAdjustments != this.props.inventoryAdjustments) {
            this.setState({
                rows: nextProps.inventoryAdjustments
            });
        }
        if(nextProps.adjustmentDetail && nextProps.adjustmentDetail != this.props.adjustmentDetail) {
          let adjustmentDetail = {...this.state.adjustmentDetail, rows: nextProps.adjustmentDetail.Warehouse_Adjustment_Line}
          this.setState({adjustmentDetail})
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set inventoryAdjustments being selected to be currentInventoryAdjustment and navigate user to the edit page

    setCurrentInventoryAdjustment(e) {
        e.preventDefault();
        const currentInventoryAdjustment = this.state.selectedRows[0];
        this.props.resetCurrentInventoryConvert();
        this.props.selectInventoryAdjustment(currentInventoryAdjustment);
        this.context.router.push('/inventories/adjustment/' + currentInventoryAdjustment.WarehouseAdjustment_id)
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentInventoryAdjustment();
        this.props.resetCurrentInventoryConvert();
        this.context.router.push('/inventories/adjustment/new')
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const onRowsSelected = (rows) => {
                let newRows = getRows();
                let selectedRows = [newRows[rows[0].rowIdx]];
                newRows.map(r => {
                  r.isSelected = false;
                });
                rows.map(r => {
                  newRows[r.rowIdx].isSelected = true;
                });
                this.setState({ rows: newRows, selectedRows: selectedRows });
            }
            const onRowsDeselected = (rows) => {
                let rowIndexes = rows.map(r => r.rowIdx);
                let newRows = [...this.state.salesOrders.rows];
                rows.map (r => {
                  newRows[r.rowIdx].isSelected = false;
                });
                this.setState({ rows: newRows, selectedRows: selectedRows });
            }

            const onRowClick = (rowIdx, row) => {
              if(rowIdx != -1) {
                let rows = getRows();
                rows.map(row => {
                  row.isSelected = false;
                });

                rows[rowIdx].isSelected = true;
                this.setState({ rows: rows, selectedRows: [rows[rowIdx]] });
                this.props.fetchInventoryAdjustmentsDetail(rows[rowIdx].WarehouseAdjustment_id);
              }
            }

            const onCellSelected =(coordinates) => {
                let newRows = getRows();
                let selectedRows = [newRows[coordinates.rowIdx]];
                newRows.map(r => {
                  r.isSelected = false;
                });
                newRows[coordinates.rowIdx].isSelected = true;
                this.setState({ rows: newRows, selectedRows: selectedRows });
            }

            // Column difinition

            const columns = [
                {
                    key: 'Modify_Username',
                    name: <Translate value="user" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 100,
                },
                {
                    key: 'PostingDate',
                    name: <Translate value="posting_date" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    formatter: DateFormatter,
                    width: 120,
                },
                {
                    key: 'ProductNum',
                    name: <Translate value="prod_num" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 100,
                },
                {
                    key: 'ProductName',
                    name: <Translate value="name" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 200,
                },
                {
                    key: 'ProductDescription',
                    name: <Translate value="desc" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 200,
                },
                {
                    key: 'From',
                    name: <Translate value="from" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 80,
                },
                {
                    key: 'To',
                    name: <Translate value="to" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 80,
                },
                {
                    key: 'WarehouseName',
                    name: <Translate value="warehouse" />,
                    resizable: true,
                    sortable: true,
                    filterable: true,
                    width: 155,
                },
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="InventoryAdjustments-dataGrid1">
                    <ReactDataGrid
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={380}
                        enableRowSelect='single'
                        rowSelection={{
                          showCheckbox: true,
                          onRowsSelected: onRowsSelected,
                          onRowsDeselected: onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected'
                          }
                        }}
                        onRowClick={onRowClick}
                        onCellSelected={onCellSelected}
                        />
                </div></Col></Row>
            )
        }
    }

    renderDetailTable() {
      if (this.props.adjustmentDetailIsLoading && !this.props.adjustmentDetailError) return <Spinner/>
      else if (this.props.adjustmentDetailError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.adjustmentDetailError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.adjustmentDetail);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var state = Object.assign({}, this.state.adjustmentDetail, { sortColumn: sortColumn, sortDirection: sortDirection });
              this.setState({adjustmentDetail});
          }

          const handleFilterChange = filter => {
              let newFilters = Object.assign({}, this.state.adjustmentDetail.filters);
              if (filter.filterTerm) {
                  newFilters[filter.column.key] = filter;
              } else {
                  delete newFilters[filter.column.key];
              }
              let adjustmentDetail = {...this.state.adjustmentDetail, filters: newFilters}
              this.setState({ adjustmentDetail });
          }


          const DateFormatter = React.createClass({
              render() {
                  if (this.props.value) {
                    let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let date = new Date(this.props.value)
                    let index = dateMap.indexOf(date.toString().slice(4,3));
                    let localDate = index + date.toString().slice(8, 6);
                    return <span>{date.toString().slice(4, 15)}</span>;;
                  }
                  else return <span className="label label-danger">-</span>;
              }
          });

          // Column difinition

          const columns = [
              {
                  key: 'Batch_PONum',
                  name: <Translate value="batch_num" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 100,
              },
              {
                  key: 'From',
                  name: <Translate value="from" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 100,
              },
              {
                  key: 'To',
                  name: <Translate value="to" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 100,
              },
              {
                  key: 'WarehouseZone_Name',
                  name: <Translate value="zone" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 140,
              },
              {
                  key: 'WarehouseBin_Name',
                  name: <Translate value="bin" />,
                  resizable: true,
                  sortable: true,
                  filterable: true,
                  width: 100,
              },
          ]

          return (
              <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="InventoryAdjustments-dataGrid2">
                  <ReactDataGrid
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowHeight={25}
                      minHeight={250}
                      rowGetter={rowGetter}
                      rowsCount={getSize() }
                      />
              </div></Col></Row>
          )
      }
    }

    checkPermission(permission) {
        return false;
    }

    render() {
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="inventory_adjustments" />
                </Breadcrumb.Item>
              </Breadcrumb> {/* End Nav Trail */}
              <Grid fluid="true" id="inventory-adjustments">
                <ButtonToolbar className="table-buttons">
                    {/* <Button href="/inventories"  bsStyle="primary" ><em className="fa fa-mail-reply"/></Button> */}
                    {/* <Button bsStyle="primary" onClick={(e) => this.clickNew(e) } disabled={true || this.checkPermission("add_warehouse_adjustment")}>
                        <em className="fa fa-plus marginRightStyle"/><Translate value="create_inventory_adjustment_sheet" />
                    </Button> */}
                    {/* }<Button bsStyle="primary">
                        <em className="fa fa-print marginRightStyle"/><Translate value="print" />
                    </Button>*/}
                    {/* <Button
                      bsStyle="primary"
                      disabled={true}
                      onClick={(event) => {this.setCurrentInventoryAdjustment(event)}}>
                        <em className="fa fa-pencil marginRightStyle"/><Translate value="edit" />
                    </Button> */}
                </ButtonToolbar>
                <br/>
                <Panel id="inventory-adjustment-full-table">
                  { this.renderTable() }
                </Panel>
                <Panel id="inventory-adjustment-details">
                  { this.renderDetailTable() }
                </Panel>
              </Grid>
            </ContentWrapper>
        );
    }
}



export default InventoryAdjustments;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryAdjustments.jsx